// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"f5b1f1df","301":"7cd9ed68","354":"d515ac05","452":"77b5859e","453":"3ca0ea6d","524":"66050f98","676":"e5c5dd3e"}[chunkId] + ".chunk.js";
};